import type { JiraSpaRoute, RouterContext } from '@atlassian/react-resource-router';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import { MENU_ID_ITOM } from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

const routes = new Set<RouteName>([
	'itom-certificates-overview',
	'itom-certificates',
	'itom-certificate-policies',
]);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName: RouteName = routeContext.route.name;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertNew(args: { routeName: RouteName }): SelectedPath {
	const { routeName } = args;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertRouteToPath(args: { routeName: RouteName; path: string[] }): SelectedPath {
	const { routeName, path } = args;

	switch (routeName) {
		case 'itom-certificates-overview':
		case 'itom-certificates':
		case 'itom-certificate-policies':
			path.push(MENU_ID_ITOM);
			break;
		default:
	}

	return path;
}

export const itomConverter: {
	routes: Set<RouteName>;
	convert: typeof convert;
	convertNew: typeof convertNew;
} = { routes, convert, convertNew };
